export default __webpack_public_path__ + "5336b8e1c76e1ab00547a7cfcc75c288.woff2";